import { useState, useContext, createContext, ReactNode } from 'react';
import { User } from '../app/pages/UserPage/type';

type AuthContextType = {
  auth: User | null;
  setAuth: (value: User | null) => void;
};

const AuthInfoContext = createContext<AuthContextType>({
  auth: null,
  setAuth: () => null
});

/**
 * @return useContext use context auth
 */
export function useAuth(): AuthContextType {
  return useContext(AuthInfoContext);
}

type Props = {
  children: ReactNode;
};

/**
 * @return AuthProvider provider value auth
 */
export function AuthProvider({ children }: Props) {
  const [auth, setAuth] = useState<User | null>(null);
  const value = { auth, setAuth };

  return <AuthInfoContext.Provider value={value}>{children}</AuthInfoContext.Provider>;
}
